/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BlogFieldMap } from './BlogFieldMap';
import {
    BlogFieldMapFromJSON,
    BlogFieldMapFromJSONTyped,
    BlogFieldMapToJSON,
} from './BlogFieldMap';

/**
 * 
 * @export
 * @interface BlogModule
 */
export interface BlogModule {
    /**
     * 
     * @type {boolean}
     * @memberof BlogModule
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BlogModule
     */
    wp_username?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogModule
     */
    wp_app_password?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogModule
     */
    wp_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BlogModule
     */
    json_url?: string;
    /**
     * 
     * @type {BlogFieldMap}
     * @memberof BlogModule
     */
    json_field_map?: BlogFieldMap;
}

/**
 * Check if a given object implements the BlogModule interface.
 */
export function instanceOfBlogModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BlogModuleFromJSON(json: any): BlogModule {
    return BlogModuleFromJSONTyped(json, false);
}

export function BlogModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'wp_username': !exists(json, 'wp_username') ? undefined : json['wp_username'],
        'wp_app_password': !exists(json, 'wp_app_password') ? undefined : json['wp_app_password'],
        'wp_url': !exists(json, 'wp_url') ? undefined : json['wp_url'],
        'json_url': !exists(json, 'json_url') ? undefined : json['json_url'],
        'json_field_map': !exists(json, 'json_field_map') ? undefined : BlogFieldMapFromJSON(json['json_field_map']),
    };
}

export function BlogModuleToJSON(value?: BlogModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'wp_username': value.wp_username,
        'wp_app_password': value.wp_app_password,
        'wp_url': value.wp_url,
        'json_url': value.json_url,
        'json_field_map': BlogFieldMapToJSON(value.json_field_map),
    };
}

